import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Customer } from 'api';

export const useOpportunityId = () => {
	const [searchParams] = useSearchParams();

	useEffect(() => {
		const opportunityId = searchParams.get('opportunityId');
		if (opportunityId) {
			localStorage.setItem('opportunityId', String(opportunityId));
		}

		var customerData: Customer = {
			companyName: searchParams.get('companyName'),
			address: searchParams.get('companyAddress'),
			country: searchParams.get('companyCountry'),
			city: searchParams.get('companyCity')
		};

		localStorage.setItem('customerData', JSON.stringify(customerData));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
};
